<template lang="pug">
  b-form-checkbox(
    v-model="dropout",
    :value="true",
    :unchecked-value="false",
    @change="$emit('input', { dropout: $event })"
  ) patient is definetely overdue and should drop out
</template>

<script>
export default {
  data() {
    return {
      dropout: this.value.dropout === true,
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
}
</script>
